import { InjectionToken } from '@angular/core';

/**
 * Token used for providing the IEntityComponentsDocumentsModuleConfig
 * @example
 * // in the app or shared modules providers section
 * providers: [
 *     { provide: EntityComponentsDocumentsModuleConfigToken, useValue: entityComponentsDocumentsModuleConfig },
 * ],
 */
const EntityComponentsDocumentsModuleConfigToken = new InjectionToken('entity_components_documents_module_config');

/**
 * Generated bundle index. Do not edit.
 */

export { EntityComponentsDocumentsModuleConfigToken };

//# sourceMappingURL=mt-ng2-entity-components-documents-config.js.map